export const URL = 'https://financialmodelingprep.com/api/v3/';
export const Sectors = 'sectors-performance';
export const Companies = 'stock-screener';
export const Company = 'profile/';
export const APIKey = '34e63e51340d93d9d3a2c884a23c2310';
